import React, { FC } from 'react'
import { Colors, CustomerTypes } from '../..';
import { Icon } from '../general/Icon';

interface Props {
	value: string;
	size?: number;
}
export const CustomerTypeIcon: FC<Props> = ({ value, size = 34 }) => {
	switch (value) {
		case CustomerTypes.BUSINESS:
			return <Icon size={size} icon={'customers-commercial'} color={Colors.gray} />;
		case CustomerTypes.HOUSING_INDUSTRY:
			return <Icon size={size} icon={'customers-housing'} color={Colors.gray} />;
		case CustomerTypes.MAJOR_CUSTOMERS:
			return <Icon size={size} icon={'customers-major'} color={Colors.gray} />;
		default:
			return <Icon size={size} icon={'customers-commercial'} color={Colors.gray} />;
	}
}